module.exports = __webpack_public_path__ + "static/media/OpenSansCondensed-Bold.a16a0e83.ttf";